@if (environment) {
  <mat-card class="container">
    <mat-card-title>Editing: {{environment.Name}}</mat-card-title>
    @if (viewModel) {
      <mat-card-content>
        <h3>Valid Applications</h3>
        @for (a of viewModel.Environment.SupportedConfigProviders; track a) {
          <div>
            {{a}}
          </div>
        }
        <hr />
        <h3>Agent</h3>
        <mat-select data-qa-id="edit-environment-select-agent" placeholder="Agent"
          [(ngModel)]="viewModel.Environment.AgentId">
          <mat-option [value]="null">None</mat-option>
          @for (agent of viewModel.Agents; track agent) {
            <mat-option [value]="agent.Id">{{agent.Name}}</mat-option>
          }
        </mat-select>
        <br />
        <br />
        <mat-checkbox data-qa-id="edit-environment-checkbox-can-see-apis" [(ngModel)]="viewModel.CanSeeApis">ACT Can see the site APIs? (improves performance if so)</mat-checkbox>
        <br />
        <hr />
        <button data-qa-id="edit-environment-btn-save-changes" mat-raised-button class="mat-accent" (click)="save();">Save Changes</button>
      </mat-card-content>
    }
  </mat-card>
}
@if (viewModel) {
  <div>
    @for (vm of viewModel.EditModels; track vm) {
      <mat-card>
        <mat-card-title>{{vm.Name}}</mat-card-title>
        <mat-card-subtitle>{{vm.Type}}</mat-card-subtitle>
        @for (setting of vm.PropertyEditModels; track setting) {
          <div>
            @if (setting.ControlType === 'text') {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>{{setting.PropertyName}}</mat-label>
                  <input matInput type="text" [placeholder]="setting.PropertyName" [(ngModel)]="vm.Provider[setting.PropertyName]" [name]="vm.Id+setting.PropertyName" [required]="setting.Mandatory" />
                </mat-form-field>
                <br />
              </div>
            }
            @if (setting.ControlType === 'integer') {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>{{setting.PropertyName}}</mat-label>
                  <input matInput type="number" step="1" [placeholder]="setting.PropertyName" [(ngModel)]="vm.Provider[setting.PropertyName]" [name]="vm.Id+setting.PropertyName" [required]="setting.Mandatory" />
                </mat-form-field>
                <br />
              </div>
            }
            @if (setting.ControlType === 'textarea') {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>{{setting.PropertyName}}</mat-label>
                  <textarea matInput [placeholder]="setting.PropertyName" [(ngModel)]="vm.Provider[setting.PropertyName]" [name]="vm.Id+setting.PropertyName" [required]="setting.Mandatory"></textarea>
                </mat-form-field>
                <br />
              </div>
            }
            @if (setting.ControlType === 'boolean') {
              <div>
                <mat-checkbox [(ngModel)]="vm.Provider[setting.PropertyName]" [name]="vm.Id+setting.PropertyName" [required]="setting.Mandatory">{{setting.PropertyName}}</mat-checkbox>
                <br />
              </div>
            }
            @if (setting.ControlType === 'password') {
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>{{setting.PropertyName}}</mat-label>
                  <input matInput type="password" [placeholder]="setting.PropertyName" [(ngModel)]="vm.Provider[setting.PropertyName]" [name]="vm.Id+setting.PropertyName" [required]="setting.Mandatory" />
                </mat-form-field>
                <br />
              </div>
            }
            @if (setting.ControlType === 'dropdown') {
              <div>
                <mat-form-field>
                  <mat-label>{{setting.PropertyName}}</mat-label>
                  <mat-select [placeholder]="setting.PropertyName"
                    [(ngModel)]="vm.Provider[setting.PropertyName]">
                    <mat-option [value]="null"></mat-option>
                    @for (val of setting.Values; track val) {
                      <mat-option [value]="val">{{val}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <br />
              </div>
            }
            @if (setting.ControlType === 'dictionary') {
              <div>
                <span>{{setting.PropertyName}}</span>
                <table>
                  <thead>
                    <tr>
                      <th>Key</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (s of generateArray(vm.Provider[setting.PropertyName]); track s) {
                      <tr>
                        <td>{{s}}</td>
                        <td>
                          <mat-form-field appearance="fill">
                            <input matInput [(ngModel)]="vm.Provider[setting.PropertyName][s]" />
                          </mat-form-field>
                        </td>
                      </tr>
                    }
                    <tr>
                      <td>
                        <mat-form-field floatLabel="never">
                          <input matInput [(ngModel)]="newKey" />
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field floatLabel="never">
                          <input matInput [(ngModel)]="newValue" />
                        </mat-form-field>
                        <button mat-raised-button class="mat-accent" (click)="newValuePair(vm.Provider[setting.PropertyName], newKey, newValue)">&nbsp;<mat-icon>add</mat-icon></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </div>
            }
            @if (setting.ControlType === 'stringarray') {
              <div>
                <span>{{setting.PropertyName}}</span>
                <table>
                  <thead>
                    <tr>
                      <th>Key</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (s of vm.Provider[setting.PropertyName]; track s) {
                      <tr>
                        <td>
                          {{s}}
                        </td>
                      </tr>
                    }
                    <tr>
                      <td>
                        <mat-form-field floatLabel="never">
                          <input matInput [(ngModel)]="newItem" />
                        </mat-form-field>
                        <button mat-raised-button class="mat-accent" (click)="newArrayItem(vm.Provider[setting.PropertyName], newItem)">&nbsp;<mat-icon>add</mat-icon></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </div>
            }
            @if (setting.ControlType === 'agentpicker') {
              <div>
                <mat-form-field>
                  <mat-label>{{setting.PropertyName}}</mat-label>
                  <mat-select placeholder="Agent"
                    [(ngModel)]="vm.Provider[setting.PropertyName]">
                    <mat-option [value]="null">None</mat-option>
                    @for (agent of viewModel.Agents; track agent) {
                      <mat-option [value]="agent.Id">{{agent.Name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          </div>
        }
      </mat-card>
    }
  </div>
}